<template>
  <div>
    <section class="section is-medium">
      <div class="container">
        <h1 class="title">Wall Of Love: {{wolName}}</h1>
        <p>Add feedback to your Wall of Love, grab the embed code and add it to your site.</p>
        <p>The embedded Wall of Love has a minimalistic design on purpose. Easily adjust it to your site design instead of fighting against my presets :-)</p>
        
        <div class="tabs is-boxed mb-0 mt-6">
          <ul>
            <li v-bind:class="{ 'is-active': activeTab == 0 }">
              <a @click.prevent="activeTab = 0">Preview</a>
            </li>
            <li v-bind:class="{ 'is-active': activeTab == 1 }">
              <a @click.prevent="activeTab = 1">Edit</a>
            </li>
            <li v-bind:class="{ 'is-active': activeTab == 2 }">
              <a @click.prevent="activeTab = 2">Embed Code</a>
            </li>
          </ul>
        </div>
<div class="tab-panel">
        <div v-if="activeTab == 0">
          <h2 class="subtitle">Preview with minimal styling:</h2>
          <div >
            <iframe v-if="wolId"
              class="previewFrame"
              :src="'/embed/wol/'+ wolId+  '/iframe?t=0'"
            >
            </iframe>
          </div>
        </div>
        <div v-if="activeTab == 1">
          <div class="columns">
              <div class="column is-half">
                <div class="field">
                  <label class="label" for="name"
                    >Name of the Wall Of Love</label
                  >
                  <div class="control">
                    <input
                      v-model="wolName"
                      id="wolName"
                      name="wolName"
                      type="text"
                      placeholder="Name of the Wall of Love"
                      class="input"
                      :disabled="!account.has_pro_features"
                      required
                    />
                  </div>
                </div>
                <div class="field">
                  <label class="label" for="byLabel"
                    >The "By" Label</label
                  >
                  <div class="control">
                    <input
                      v-model="byLabel"
                      id="byLabel"
                      name="byLabel"
                      type="text"
                      placeholder="By"
                      class="input"
                      :disabled="!account.has_pro_features"
                      required
                    />
                  </div>
                </div>
            <div class="field">
              <label class="label" for="showAnonymousLabel"
                >Show "By anonymous" Line
              </label>
              <div class="control">
                <label class="radio">
                  <input type="radio" name="showAnonymousLabel" v-model="showAnonymousLabel" v-bind:value="true" :disabled="!account.has_pro_features">
                  yes
                </label>
                <label class="radio">
                  <input type="radio" name="showAnonymousLabel" v-model="showAnonymousLabel" v-bind:value="false" :disabled="!account.has_pro_features">
                  no
                </label>
              </div>
              <p class="help">
                You can remove the "By anonymous" line for anonymous readers.
              </p>
            </div>
                <div class="field">
                  <label class="label" for="anonymousLabel"
                    >Label for an Anonymous Reader</label
                  >
                  <div class="control">
                    <input
                      v-model="anonymousLabel"
                      id="anonymousLabel"
                      name="anonymousLabel"
                      type="text"
                      placeholder="By"
                      class="input"
                      required
                      :disabled="!account.has_pro_features"
                    />
                  </div>
                </div>
                            <div class="field">
              <label class="label" for="showFormName"
                >Show Survey Name on Wall of Love
              </label>
              <div class="control">
                <label class="radio">
                  <input type="radio" name="showFormName" v-model="showFormName" v-bind:value="true" :disabled="!account.has_pro_features">
                  yes
                </label>
                <label class="radio">
                  <input type="radio" name="showFormName" v-model="showFormName" v-bind:value="false" :disabled="!account.has_pro_features">
                  no
                </label>
              </div>
              <p class="help">
                If set to yes it will show the name of the survey on the Wall of Love.
              </p>
            </div>

            <div class="field">
              <label class="label">Style/Theme</label>
              <div class="control">
                  <div class="select">
                    <select v-model="style">
                      <option value="none">Unstyled | You provide CSS styling</option>
                      <option value="minimal">Minimal</option>
                    </select>
                  </div>
              </div>
              <p class="help">
                Use our minimal theme for the Wall of Love or have full control over display with your own CSS.
              </p>
            </div>

            <div class="field">
              <label class="label">View Mode</label>
              <div class="control">
                  <div class="select">
                    <select v-model="viewMode">
                      <option value="grid">Grid</option>
                      <option value="carousel">Carousel</option>
                    </select>
                  </div>
              </div>
              <p class="help">
                Let your WoL display the feedback in a 3-column grid or using a carousel. The carousel uses the Embla Carousel JS library.
              </p>
            </div>
            <div class="field">
              <label class="label" for="showTimestamp"
                >Show Timestamp on Feedback Card
              </label>
              <div class="control">
                <label class="radio">
                  <input type="radio" name="showTimestamp" v-model="showTimestamp" value="true" :disabled="!account.has_pro_features">
                  yes
                </label>
                <label class="radio">
                  <input type="radio" name="showTimestamp" v-model="showTimestamp" value="false" :disabled="!account.has_pro_features">
                  no
                </label>
              </div>
              <p class="help">
                You can remove the FeedLetter branding on the WoL.
              </p>
            </div>
            <div class="field">
              <label class="label" for="showBranding"
                >Show FeedLetter Branding
              </label>
              <div class="control">
                <label class="radio">
                  <input type="radio" name="showBranding" v-model="showBranding" value="true" :disabled="!account.has_pro_features">
                  yes
                </label>
                <label class="radio">
                  <input type="radio" name="showBranding" v-model="showBranding" value="false" :disabled="!account.has_pro_features">
                  no
                </label>
              </div>
              <p class="help">
                You can remove the FeedLetter branding on the WoL.
              </p>
            </div>
                  <div class="field is-grouped mt-4 mb-6">
                    <div class="control">
                      <button
                        :disabled="!saveBtnEnabled"
                        v-bind:class="{ 'is-loading': isSaving }"
                        class="button is-primary is-outlined"
                        @click.prevent="saveWallOfLove"
                      >
                        Save WoL Settings
                      </button>
                                      <span
                  v-if="!account.has_pro_features"
                  class="tag is-success"
                  >PRO</span
                >
                <router-link
                  v-if="!account.has_pro_features"
                  :to="{ name: 'Upgrade' }"
                  class="tag is-info"
                  >Unlock Now</router-link
                >
                    </div>
                  </div>
                </div>
              
          </div>
          <div class="columns">
              <div class="column">
                <h2 class="subtitle">Feedback On Your Wall of Love:</h2>
                <div v-if="selectedFeedback.length ==0" class="mt-6">
                  <p class="has-text-centered pt-6">
                      <span class="icon is-large is-size-1 has-text-grey		">
                        <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-coffee"><path d="M18 8h1a4 4 0 0 1 0 8h-1"></path><path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"></path><line x1="6" y1="1" x2="6" y2="4"></line><line x1="10" y1="1" x2="10" y2="4"></line><line x1="14" y1="1" x2="14" y2="4"></line></svg>
                      </span>
                  </p>
                  <p class="has-text-centered mt-3">
                    Yay, the smell of something new.
                  </p>
                  <p class="has-text-centered mt-3">
                    Add feedback from the right side to your Wall of Love.
                  </p>
                </div>
                <div v-for="r in selectedFeedback"
            v-bind:key="r.id">
              <WoLFeedbackCard :reason="r" :subscribed="subscribed" :inwol="true" :showFormName="showFormName"/>
                </div>
              </div>
              <div class="column">
                <h2 class="subtitle">Add Feedback:</h2>
                <div class="field has-addons ">
                    <p class="control is-expanded">
                        <input v-model="searchTerm" @keyup.enter="loadSelectableFeedback" class="input" type="text" placeholder="Search your feedback">
                    </p>
                    <p class="control">
                        <a class="button is-primary" @click.prevent="loadSelectableFeedback">
                            Search
                        </a>
                    </p>
                </div>
                <p class="mb-6">
                  <a @click.prevent="addAllEligibleToWol">Add all shown feedback to WoL</a>
                </p>
                <div v-if="limitReached" class="box m-1 has-text-centered content">
                  <p>
                    Max feedback on Wall of Love reached. Upgrade to Professional or Business to add more.
                  </p>
                  <p>
                    <router-link
                      :to="{ name: 'Upgrade' }"
                      class="button is-small is-info is-inline"
                      >Unlock Now</router-link
                    >
                  </p>
                </div>
                <div id="selectableFeedback" v-for="r in selectableFeedback"
            v-bind:key="r.id">
                  <WoLFeedbackCard :reason="r" :subscribed="subscribed" :inwol="false" :enabled="!limitReached" :showFormName="showFormName" />
                </div>
                <div v-if="!subscribed" class="box m-1 has-text-centered content">
                  <p>
                    Upgrade to Professional or Business to access all feedback.
                  </p>
                  <p>
                    <router-link
                      :to="{ name: 'Upgrade' }"
                      class="button is-small is-info is-inline"
                      >Unlock Now</router-link
                    >
                  </p>
                </div>
              </div>
          </div>
        </div>
        <div v-if="activeTab == 2">

            <h2 class="subtitle">
              Copy a block and paste it into your page.
            </h2>
            <div class="columns">
              <div class="column">
                <p class="has-text-right">

                <a
                  class="button is-small"
                  @click.prevent="copyAsJS"
                  v-bind:class="{ 'has-text-success': copiedJS }"
                  >{{ copyAsJSButton }}</a
                >
              </p>
              <div class="content is-small box ">
                <textarea id="formWidgetJS">
                   &lt;div id="feedletter-wol"&gt;&lt;/div&gt;
              &lt;script type="text/javascript" defer src="https://feedletter.co/embed/wol/{{wolId}}"&gt;&lt;/script&gt;
                </textarea>
                <p><pre>&lt;div id="feedletter-wol"&gt;&lt;/div&gt;
&lt;script type="text/javascript" defer src="https://feedletter.co/embed/wol/{{wolId}}"&gt;&lt;/script&gt;

  // add the code where you want to show the wall of love </pre></p>

              </div>
            </div>
            
          </div>
        </div>
</div>
      </div>
    </section>
  </div>
</template>

<script>
import atomic from "atomicjs"
import { mapState } from "vuex"
import WoLFeedbackCard from "@/components/WoLFeedbackCard.vue"
import WoLFeedbackEdit from "@/components/WoLFeedbackEdit.vue"
import {isFeedbackBlocked} from "../lib/commons"
import {trackEvent}  from "../lib/flevents"

export default {
  name: "userwalloflove",
  components: { WoLFeedbackCard, WoLFeedbackEdit },
  data: function () {
    return {
      activeTab: 1,
      isSaving: false,
      saveBtnEnabled: false,
      wolId: null,
      wolName: null,
      byLabel: "By",
      showAnonymousLabel: true,
      showFormName: false,
      anonymousLabel: "anonymous",
      copiedJS: false,
      copyAsJSButton: "Copy as JS Embed",
      selectableFeedback: [],
      selectedFeedback: [],
      searchTerm: null,
      style: "none",
      viewMode: "grid",
      showBranding: true,
      showTimestamp: false
    };
  },
  computed: {
    subscribed() {
      return this.account.subscribed;
    },
    ...mapState(["user", "account"]),
    feedbackLimit() {
      if (this.account.has_biz_features) {
        return 1000
      } else if(this.account.has_pro_features) {
        return 23
      }
      return 3
    },
    limitReached() {
      console.log(this.selectedFeedback.length, this.feedbackLimit, this.selectedFeedback.length >= this.feedbackLimit)
      if (this.selectedFeedback.length >= this.feedbackLimit) {
        return true
      }
      return false
    }
  },
    watch: {
    wolName: function (val) {
      this.saveBtnEnabled = this.subscribed && val !== null && val !== "";
    },
    activeTab: function (val) {
      trackEvent(this.$store.state.user.id, "wol-edit-tab-view-" + this.activeTab)
    }
  },
  mounted: function () {
    if (!this.user.isLoggedIn) {
      this.$router.push("/login");
      return
    }
    this.wolId = this.$route.params.wolId;
    this.loadWallOfLove().then((value) => {
      this.loadSelectableFeedback()
    }
    )
    trackEvent(this.$store.state.user.id, "wol-edit-view")
  },
  methods: {
    copyAsJS: function () {
      if(!this.account.subscribed) {
        return
      }
      let formWidgetJS = document.getElementById("formWidgetJS");
      formWidgetJS.select();

      try {
        document.execCommand("copy");
        this.copiedJS = true;
        this.copyAsJSButton = "Copied as JS Embed";
      } catch (err) {
        alert("Unable to copy");
      }

      /* unselect the range */
      window.getSelection().removeAllRanges();
    },
    showEditAndAddForm: function(feedback) {
      this.$buefy.modal.open({
        parent: this,
        component: WoLFeedbackEdit,
        hasModalCard: true,
        canCancel: true,
        width: 640,
        trapFocus: true,
        props: {
          feedback: feedback,
          wolid: this.wolId
        }
      })
    },
    addAllEligibleToWol: async function() { 
      
      var self = this;

      let feedbackIdsToAdd= []
      let feedbackToAdd= []

      for(var i=0; i<= this.selectableFeedback.length; i++) {
        let feedback = this.selectableFeedback[i]
        if(!isFeedbackBlocked(feedback)) {
          feedbackIdsToAdd.push(feedback.id)
          feedbackToAdd.push(feedback)
        }
        if(this.feedbackLimit - this.selectedFeedback.length - feedbackToAdd.length ==0) {
          break;
        }
      }

      this.$store.dispatch('getAPIToken')
        .then((token) => {
          let loadingComponent = this.$buefy.loading.open({
            container: document.getElementById("selectableFeedback")
          })
          let url = self.apiHost + "walloflove/" + this.wolId + "/feedback"
          return atomic(url, {
            method: "POST",
            headers: {
              Authorization: "Bearer " + token,
              "Content-type": "application/json",
            },
            data: {
              "wol_id": self.wolId,
              "feedback_ids": feedbackIdsToAdd
            }
          })
            .then(function (response) {
              self.selectedFeedback.push(...feedbackToAdd)
              self.loadSelectableFeedback()
              loadingComponent.close()
              self.$buefy.toast.open({
                duration: 3000,
                message: `All eligible Feedback added to Wall of Love`,
                type: 'is-success'
              })
              //console.log(response.data); // xhr.responseText
              //console.log(response.xhr); // full response
            })
            .catch(function (error) {
              loadingComponent.close()
              let msg = `Oops! Something went wrong but it wasn't you. It was us and the team was already notified. Please try again later.`
              if(error.status === 403) {
                msg =`Access Denied: You don't have rights to access this Wall of Love.`
              }
              self.$buefy.toast.open({
                duration: 5000,
                message: msg,
                type: 'is-danger'
              })
              console.log(error.status); // xhr.status
              console.log(error.statusText); // xhr.statusText
            })
        })
        .catch((error) => {
          this.$parent.$emit("unauthed")
        });

    },
    addToWol: async function(feedback) { 
      
      var self = this;
      this.$store.dispatch('getAPIToken')
        .then((token) => {
          let loadingComponent = this.$buefy.loading.open({
            container: document.getElementById("fb-" +feedback.id)
          })
          let url = self.apiHost + "walloflove/" + this.wolId + "/feedback"
          return atomic(url, {
            method: "POST",
            headers: {
              Authorization: "Bearer " + token,
              "Content-type": "application/json",
            },
            data: {
              "wol_id": self.wolId,
              "feedback_ids": [feedback.id]
            }
          })
            .then(function (response) {
              self.selectedFeedback.push(feedback)
              self.selectableFeedback.splice(self.selectableFeedback.findIndex(v => v.id === feedback.id), 1)
              loadingComponent.close()
              self.$buefy.toast.open({
                duration: 3000,
                message: `Feedback added to Wall of Love`,
                type: 'is-success'
              })
              //console.log(response.data); // xhr.responseText
              //console.log(response.xhr); // full response
            })
            .catch(function (error) {
              loadingComponent.close()
              let msg = `Oops! Something went wrong but it wasn't you. It was us and the team was already notified. Please try again later.`
              if(error.status === 403) {
                msg =`Access Denied: You don't have rights to access this Wall of Love.`
              }
              self.$buefy.toast.open({
                duration: 5000,
                message: msg,
                type: 'is-danger'
              })
              console.log(error.status); // xhr.status
              console.log(error.statusText); // xhr.statusText
            })
        })
        .catch((error) => {
          this.$parent.$emit("unauthed")
        });

    },
    removeFromWol: async function(feedback) {
      var self = this;
      this.$store.dispatch('getAPIToken')
        .then((token) => {
          let loadingComponent = this.$buefy.loading.open({
            container: document.getElementById("fb-" +feedback.id)
          })
          let url = self.apiHost + "walloflove/" + this.wolId + "/feedback"
          return atomic(url, {
            method: "DELETE",
            headers: {
              Authorization: "Bearer " + token,
              "Content-type": "application/json",
            },
            data: {
              "wol_id": self.wolId,
              "feedback_id": feedback.id
            }
          })
            .then(function (response) {
              self.selectedFeedback.splice(self.selectedFeedback.findIndex(v => v.id === feedback.id), 1)
              self.selectableFeedback.push(feedback)
              loadingComponent.close()
              self.$buefy.toast.open({
                duration: 3000,
                message: `Feedback removed from Wall of Love`,
                type: 'is-success'
              })
              //console.log(response.data); // xhr.responseText
              //console.log(response.xhr); // full response
            })
            .catch(function (error) {
              loadingComponent.close()
              let msg = `Oops! Something went wrong but it wasn't you. It was us and the team was already notified. Please try again later.`
              if(error.status === 403) {
                msg =`Access Denied: You don't have rights to access this Wall of Love.`
              }
              self.$buefy.toast.open({
                duration: 5000,
                message: msg,
                type: 'is-danger'
              })
              console.log(error.status); // xhr.status
              console.log(error.statusText); // xhr.statusText
            })
        })    
        .catch((error) => {
          this.$parent.$emit("unauthed")
        });
    },
    loadSelectableFeedback: async function () {
      var self = this;
      //console.log(url)
      
      this.$store.dispatch('getAPIToken')
        .then((token) => {
          let loadingComponent = this.$buefy.loading.open({
            container: self.$refs.recentFeedbackLoading
          })
          let url = self.apiHost + "walloflove/" + self.wolId + "/feedback"
          
          if(!this.isEmptyOrSpaces(this.searchTerm)) {
            url += "?s=" + this.searchTerm
          }

          atomic(url, {
            method: "GET",
            headers: {
              Authorization: "Bearer " + token,
              "Content-type": "application/json",
            },
          })
            .then(function (response) {
              self.selectableFeedback = response.data;
              loadingComponent.close()
              //console.log(response.data); // xhr.responseText
              //console.log(response.xhr); // full response
            })
            .catch(function (error) {
              loadingComponent.close()
              console.log(error.status); // xhr.status
              console.log(error.statusText); // xhr.statusText
            });
        })
        .catch((error) => {
          this.$parent.$emit("unauthed")
        });
    },
    saveWallOfLove: async function () {
      this.isSaving = true;
      var self = this;
      var wolSettings = {
        name: this.wolName,
        anonymous_label: this.anonymousLabel,
        by_label: this.byLabel,
        show_anonymous_label: this.showAnonymousLabel,
        show_form_name: this.showFormName,
        style: this.style,
        view_mode: this.viewMode,
        show_branding: this.showBranding == true || this.showBranding === "true",
        show_timestamp: this.showTimestamp == true || this.showTimestamp === "true"
      };
      if (!this.subscribed) {
          this.$buefy.dialog.alert("<p>Editing the Wall of Love settings is only available on paid plans.</p><p  class='mt-3'> <a href='/upgrade'>Upgrade Now</a></p>")
          return
      }
      this.$store.dispatch('getAPIToken')
        .then((token) => {
          atomic(this.apiHost + "walloflove/" + this.wolId, {
            method: "PUT",
            headers: {
              Authorization: "Bearer " + token,
              "Content-type": "application/json",
            },
            data: wolSettings,
          }).then(async function (response) {

            self.$buefy.toast.open({
              duration: 3000,
              message: `Wall Of Love Settings successfully updated`,
              type: 'is-success'
            })
            self.isSaving = false;
          })
          .catch(function (error) {
              self.isSaving = false;
              self.$buefy.toast.open({
                duration: 3000,
                message: `Updating Wall Of Love Settings failed: ` + error.statusText,
                type: 'is-danger'
              })
              console.log(error.status); // xhr.status
              console.log(error.statusText); // xhr.statusText
            });
        })
        .catch((error) => {
          this.$parent.$emit("unauthed")
        });
    },
    loadWallOfLove: async function () {
        var self = this;
        return this.$store.dispatch('getAPIToken')
        .then((token) => {
            //console.log("get user details");
            return atomic(self.apiHost + "walloflove/"+ this.wolId, {
              method: "GET",
              headers: {
                Authorization: "Bearer " + token,
                "Content-type": "application/json",
              },
            })
              .then(function (response) {
                self.wolName = response.data.name
                self.byLabel = response.data.by_label
                self.anonymousLabel = response.data.anonymous_label
                self.showAnonymousLabel = response.data.show_anonymous_label
                self.showFormName = response.data.show_form_name
                self.selectedFeedback = response.data.feedback
                self.style = response.data.style
                self.viewMode = response.data.view_mode
                self.showBranding = response.data.show_branding
                self.showTimestamp = response.data.show_timestamp
                

                //self.$emit("setwolDetails", self.user);
                //console.log(response.data); // xhr.responseText
                //console.log(response.xhr); // full response
              })
              .catch(function (error) {
                console.log(error.status); // xhr.status
                console.log(error.statusText); // xhr.statusText
              });
          })
        .catch((error) => {
          this.$parent.$emit("unauthed")
        });
    },
  },
};
</script>

<style>
#feedletter-wol .wol {
      width: 100%;
      overflow: hidden;
      padding: 1rem;
      -webkit-column-count: 3;
      -webkit-column-gap: 1.875em;
      -webkit-column-fill: auto;
      -moz-column-count: 3;
      -moz-column-gap: 1.875em;
      -moz-column-fill: auto;
      column-count: 3;
      column-gap: 1.875em;
      column-fill: auto;
    }

    #feedletter-wol .wol .item {
      background-color: white;
      background-color: #fff;
      text-align: center;
      border-radius: 6px;
      box-shadow: 0 2px 3px rgb(10 10 10 / 10%), 0 0 0 1px rgb(10 10 10 / 10%);
      color: #4a4a4a;
      display: block;
      padding: 1.25rem;
      -webkit-column-break-inside: avoid;
      -moz-column-break-inside: avoid;
      column-break-inside: avoid;
    }
</style>